import { colors, space } from './core'
import { textStyles } from './typography'

const questionsAndHints = {
  questions: {
    ...textStyles.body.large.medium,
    color: `${colors.neutrals[4]}`
  },
  button: {
    '&:hover': {
      svg: {
        path: {
          fill: `${colors.secondary[2]}`
        }
      }
    },
    svg: {
      path: {
        fill: `${colors.secondary[1]}`
      }
    }
  },
  hints: {
    ...textStyles.body.current.regular,
    backgroundColor: `${colors.tertiary[0]}`,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '8px',
    borderColor: colors.tertiary[2],
    padding: `${space[4]}px`,
    outline: 0,
    width: '100%'
  }
}

export default questionsAndHints
